export function surveyElementsCore(): string {
  return 'survey-elements-core';
}
